import { helpers } from '@mf-node/mf-vue-components'

export const getWhitelabelConfiguration = helpers.whitelabel.getWhitelabelConfiguration

export default {
  install(Vue, { env }) {
    Vue.prototype.$getWhitelabelConfiguration = Vue.getWhitelabelConfiguration = getWhitelabelConfiguration
  },
}
